import { Skeleton, Stack } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import { Cell } from '@/core/architecture'

type RankingUserDataSoloSkeletonProps = {
  isSolo?: boolean
}

export const RankingUserDataSkeleton: Cell<RankingUserDataSoloSkeletonProps> =
  ({ isSolo }) => (
    <Stack
      spacing={3}
      direction="row"
      sx={{
        pt: 3,
        borderRadius: 1,
        ...(isSolo ? { bgcolor: 'grey.50', px: 3 } : {}),
      }}
    >
      <Skeleton variant="rectangular" width={36} height={36} />
      <Stack flex={1}>
        <Stack direction="row" spacing={3} sx={{ pb: 3 }}>
          <Skeleton variant="circular" width={36} height={36} />
          <Stack spacing={1} flex={1}>
            <SkeletonText variant="small" width="50%" />
            <SkeletonText variant="small" width="25%" />
          </Stack>
        </Stack>
        {!isSolo && <Skeleton variant="rectangular" width="100%" height={1} />}
      </Stack>
    </Stack>
  )
